import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Rocket } from 'lucide-react';
import MultiSelectFilter from '../MultiSelectFilter';

const ProductFilters = ({
  searchQuery, setSearchQuery,
  sortBy, setSortBy,
  filterCategories, setFilterCategories,
  filterBrands, setFilterBrands,
  filterOccasions, setFilterOccasions,
  filterStockStatuses, setFilterStockStatuses,
  filterStockMin, setFilterStockMin,
  filterStockMax, setFilterStockMax,
  filterFabrics, setFilterFabrics,
  filterColors, setFilterColors,
  filterSizes, setFilterSizes,
  filterPriceMin, setFilterPriceMin,
  filterPriceMax, setFilterPriceMax,
  filterVendors, setFilterVendors,
  filterVendorCities, setFilterVendorCities,
  filterAgings, setFilterAgings,
  filterForwarding, setFilterForwarding,
  customColorInput, setCustomColorInput,
  addingColor, addCustomColor,
  hasActiveFilters, clearAllFilters,
  enums, brands, vendors, vendorCities,
  canViewVendor,
}) => {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <Input placeholder="Search by design number..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-52 h-10" data-testid="product-search-input" />
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="h-10 rounded-md border border-input bg-background px-3 py-2 text-sm min-w-[170px]" data-testid="product-sort-select">
          <option value="design_asc">Design No. (A-Z)</option>
          <option value="design_desc">Design No. (Z-A)</option>
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="last_modified">Last Modified</option>
          <option value="stock_high">Stock (High to Low)</option>
          <option value="stock_low">Stock (Low to High)</option>
          <option value="price_high">Price (High to Low)</option>
          <option value="price_low">Price (Low to High)</option>
        </select>
        <MultiSelectFilter label="Categories" testId="product-filter-category" selected={filterCategories} onChange={setFilterCategories}
          options={enums.categories.map(c => ({ value: c, label: c }))} />
        <MultiSelectFilter label="Brands" testId="product-filter-brand" selected={filterBrands} onChange={setFilterBrands}
          options={brands.map(b => ({ value: b.id, label: b.name }))} />
        <MultiSelectFilter label="Occasions" testId="product-filter-occasion" selected={filterOccasions} onChange={setFilterOccasions}
          options={enums.design_themes.map(t => ({ value: t, label: t }))} />
        <MultiSelectFilter label="Stock Status" testId="product-filter-stock-status" selected={filterStockStatuses} onChange={setFilterStockStatuses}
          options={[{ value: 'in_stock', label: 'In Stock' }, { value: 'out_of_stock', label: 'Out of Stock' }, { value: 'reserved', label: 'Reserved' }]} />
        <div className="flex items-center gap-1">
          <Input type="number" placeholder="Stock min" value={filterStockMin} onChange={e => setFilterStockMin(e.target.value)} className="w-24 h-10 text-xs" data-testid="product-filter-stock-min" />
          <span className="text-gray-400 text-xs">to</span>
          <Input type="number" placeholder="Stock max" value={filterStockMax} onChange={e => setFilterStockMax(e.target.value)} className="w-24 h-10 text-xs" data-testid="product-filter-stock-max" />
          <span className="text-xs text-gray-400">pcs</span>
        </div>
        <MultiSelectFilter label="Fabrics" testId="product-filter-fabric" selected={filterFabrics} onChange={setFilterFabrics}
          options={(enums.fabrics || []).map(f => ({ value: f, label: f }))} />
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <MultiSelectFilter label="Colors" testId="product-filter-color" selected={filterColors} onChange={setFilterColors}
          options={enums.colors.map(c => ({ value: c, label: c }))} />
        <div className="flex items-center gap-1">
          <Input placeholder="New color..." value={customColorInput} onChange={e => setCustomColorInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCustomColor(); } }}
            className="w-28 h-10 text-xs" data-testid="custom-color-input" />
          <Button size="sm" variant="outline" className="h-10 text-xs px-2 border-emerald-300 text-emerald-700 hover:bg-emerald-50" onClick={addCustomColor} disabled={addingColor || !customColorInput.trim()} data-testid="add-custom-color-btn">
            + Add
          </Button>
        </div>
        <MultiSelectFilter label="Sizes" testId="product-filter-size" selected={filterSizes} onChange={setFilterSizes}
          options={enums.sizes.map(s => ({ value: s, label: s }))} />
        <div className="flex items-center gap-1">
          <Input type="number" placeholder="Min WSP" value={filterPriceMin} onChange={e => setFilterPriceMin(e.target.value)} className="w-28 h-10" data-testid="product-filter-price-min" />
          <span className="text-gray-400">-</span>
          <Input type="number" placeholder="Max WSP" value={filterPriceMax} onChange={e => setFilterPriceMax(e.target.value)} className="w-28 h-10" data-testid="product-filter-price-max" />
        </div>
        {canViewVendor && (
          <>
            <MultiSelectFilter label="Vendors" testId="product-filter-vendor" selected={filterVendors} onChange={setFilterVendors}
              options={vendors.map(v => ({ value: v.id, label: v.name })).sort((a, b) => a.label.localeCompare(b.label))} />
            <MultiSelectFilter label="Vendor City" testId="product-filter-vendor-city" selected={filterVendorCities} onChange={setFilterVendorCities}
              options={vendorCities.map(c => ({ value: c, label: c })).sort((a, b) => a.label.localeCompare(b.label))} />
          </>
        )}
        <MultiSelectFilter label="Stock Aging" testId="product-filter-aging" selected={filterAgings} onChange={setFilterAgings}
          options={[
            { value: '0-30', label: '0 - 30 days' }, { value: '30-60', label: '30 - 60 days' },
            { value: '60-90', label: '60 - 90 days' }, { value: '90-120', label: '90 - 120 days' },
            { value: '120+', label: '120+ days' },
          ]} />
        <Button
          type="button"
          size="sm"
          variant={filterForwarding ? 'default' : 'outline'}
          onClick={() => setFilterForwarding(!filterForwarding)}
          className={`h-10 text-xs gap-1 ${filterForwarding ? 'bg-orange-500 hover:bg-orange-600 text-white' : 'border-orange-300 text-orange-700 hover:bg-orange-50'}`}
          data-testid="product-filter-forwarding"
          title="Show only forwarding samples (orderable, goods not yet received)"
        >
          <Rocket className="w-3.5 h-3.5" /> Forwarding only
        </Button>
        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={clearAllFilters} data-testid="clear-filters-btn">Clear All</Button>
        )}
      </div>
    </div>
  );
};

export default ProductFilters;
